/**
 * this is a TokkenR state client that interfaces with our own node
 * 
 * doc: https://run.network/docs/#api-reference-apis-state
 * code: https://github.com/runonbitcoin/run-sdk/blob/main/lib/plugins/run-db.js
 */

import { TOKKENR_NODE_HOST_URL } from "../config"
import { getLog } from "../helpers/helpers"

/*
 StateWrapper adds a lot of functionalities
 https://github.com/runonbitcoin/run-sdk/blob/main/lib/plugins/state-wrapper.js
*/
const Run = require("runlib")
const fetch = require('node-fetch')

const StateWrapper = Run.plugins.StateWrapper

/**
 * usage: 
 *      import TokkenrStateClient from "./TokkenrStateClient.js"
 *      const tokkenrStateClient = new TokkenrStateClient()
 * 
 * BEWARE THE NODE DOES NOT INDEXES BSV ADDRESSES SO IF YOU TRY TO RETRIEVE
 * UTXOS FROM A PURSE IT WILL ANSWER AN EMPTY ARRAY
 */
class TokkenrStateClient extends StateWrapper {

    // --------------------------------------------------------------------------
    // constructor
    // --------------------------------------------------------------------------

    constructor() {
        super()
        this.classname = "TokkenrStateClient"
        this.host_url = TOKKENR_NODE_HOST_URL

        let result = new Run.plugins.RunDB(this.host_url)

        // use this function to make sure the node is online & answering
        result.ping = async () => {
            const log = getLog(this.classname, "ping():")
            const url_status = this.host_url + "/status"
            try {
                let response = await fetch(url_status)
                response = await response.json()
                log("success fetching run-db status at", url_status, ":", response)
                return true
            } catch (e) {
                console.error("error fetching run-db status at" + url_status, e)
                return false
            }
        }

        // there is already a .broadcast in the default RunDB but it only pushes the tx to /tx endpoint
        // cf https://github.com/runonbitcoin/run-sdk/blob/main/lib/plugins/run-db.js
        // but we rather use /broadcast that we added that also rebroadcasts to miners with additional checks
        result.broadcast = async (rawtx) => {
            const log = getLog(this.classname, "broadcast():")
            const endpoint_url = this.host_url + "/broadcast"

            const start_time = Date.now()
            log("broadcasting tx to ", endpoint_url)

            const response = await fetch(endpoint_url, {
                method: 'POST',
                body: rawtx,
                headers: { 'content-type': 'text/plain' }
            })
            log("broadcast success in", (Date.now() - start_time), "ms")

            return response
        }

        return result
    }
}


export default TokkenrStateClient
